import request from '#/utils/request';
import { parseVer4ListResponse } from '#/api/adapters/envelope';
import {
  joinMultiValueFilters,
  listQueryToApiParams,
} from '#/utils/listUrl/parseListSearchParams';

/** 多值篩選以逗號送（be doc abbce90d：重複 filter key 回 400）。 */
export async function fetchPurchaseOrderList(listQuery) {
  const { data: raw } = await request.get('/srm/purchase-order', {
    params: listQueryToApiParams(joinMultiValueFilters(listQuery)),
  });
  return parseVer4ListResponse(raw);
}
